import { Format, FormatList } from '@celum/formats/domain';

import { createFormatStore } from './format-store.factory';
import { FORMAT_SERVICE } from '../../services/formats.service';

export const FormatStore = createFormatStore<Format, FormatList>(FORMAT_SERVICE, 'FormatStore');
